import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductSelectorComponent } from './product-selector.component';



@NgModule({
  declarations: [ProductSelectorComponent],
  imports: [
    CommonModule
  ],
  exports: [ProductSelectorComponent]
})
export class ProductSelectorModule { }
